module.exports = __webpack_public_path__ + "img/logoNew1.e545f62a.png";